import React from 'react';
import { Page, Text, View, Image } from '@react-pdf/renderer';
import dateFormat from 'dateformat';

import hgsdLogo from '../../black-textHGSDlogo400px.png';
import ftBendLogo from '../../fbsd_logo_clr_rgb.png';

function getDescription(result) {
  // 'PERMFEELAT', 'CANCELCSNP', 'CANCELPRNP', 'CSPAIDLATE'
  switch (result) {
    case 'PERMFEELAT':
      return 'Permit Fee has been paid';
    case 'CANCELCSNP':
      return 'The Compromise and Settlement offer has been voided and the permit rescinded';
    case 'CANCELPRNP':
      return 'Permit fee has been rescinded and the permit cancelled';
    case 'CSPAIDLATE':
      return 'A Compromise and Settlement has been paid';
    default:
      return 'Unknown';
  }
}

export default function AppendixG({ styles, data, year, month, footer }) {
  return (
    <Page size='A4'>
      <View style={styles.pageTitle}>
        <Text style={styles.pageTitle}></Text>
      </View>
      <View style={styles.document}>
        <View style={[styles.row, styles.borderBottom]}>
          <Image
            src={window.config.client === 'FT-BEND' ? ftBendLogo : hgsdLogo}
            style={styles.logo}
          />
          <Text style={styles.logoLabel}>Appendix G</Text>
        </View>
        <View style={[styles.row, styles.borderBottom]}>
          <Text style={styles.logo} />
          <Text style={styles.logoLabel}>
            Outcome of Permits Advertised for Cancellation
          </Text>
        </View>
        <View style={styles.section}>
          {data.length === 0 ? (
            <View style={styles.column}>
              <Text>NONE</Text>
            </View>
          ) : null}
          {data.map((permit, i) => (
            <View style={styles.section} key={i}>
              <View>
                <Text style={styles.headerLabel}>PERMITTEE:</Text>
                <Text>{permit.PERMITTEE}</Text>
              </View>
              <View>
                <Text style={styles.headerLabel}>PERMIT NO:</Text>
                <Text>{permit.CASE_NUMBER}</Text>
              </View>
              <View>
                <Text style={styles.headerLabel}>WELL NO:</Text>
                <Text>{permit.WELL_NO}</Text>
              </View>
              <View>
                <Text style={styles.headerLabel}>HEARING:</Text>
                <Text>{`${dateFormat(
                  permit.NEXT_PREV_TARGET_END_DATE,
                  'mmmm d, yyyy',
                  true
                )}`}</Text>
              </View>
              <View>
                <Text style={styles.headerLabel}>STATUS:</Text>
                <Text>{getDescription(permit.PREV_RESULT_CODE)}</Text>
              </View>
            </View>
          ))}
        </View>
      </View>
      <View fixed style={styles.footer}>
        {/* <Text style={styles.data}>{footer}</Text> */}
        <Text
          style={styles.data}
          render={({ pageNumber, totalPages }) =>
            `${footer} (${pageNumber}/${totalPages})`
          }
        />
      </View>
    </Page>
  );
}
